import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaintenanceWindowComponent } from 'src/shared/components/maintenance-window/maintenance-window.component';
import { DarkModeService } from 'src/shared/services/darkmode/darkmode_service';
import { initTranslations } from 'src/shared/translate/custom.translate.loader';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './trialsClinic.component.html',
  imports: [RouterOutlet, MaintenanceWindowComponent],
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        min-height: 100vh;
      }
      .page {
        background-color: var(--Vetai-Backgrounds--Base, #fdfdfc);
        display: block;
        width: 100%;
        min-height: 100vh;
      }
    `,
  ],
})
export class TrialsClinicComponent {
  darkModeService: DarkModeService = inject(DarkModeService);
  theme = computed(() => (this.darkModeService.darkModeOn() ? 'dark' : 'light'));
  constructor() {
    // Initialize translations
    initTranslations();

    if (environment.production) {
      // Add any production-specific initialization here
    }
  }
}
